jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
         let dailyRental = document.querySelector("daily-rental");
         dailyRental.updateQty($( "input[data-daily-rental]" ).val());
	   });
  
	   $( "input[data-daily-rental]" ).on( "change", function( evt ) {
         let dailyRental = document.querySelector("daily-rental");
         dailyRental.updateQty($( "input[data-daily-rental]" ).val());
	   });

  class GetQuote extends HTMLElement {
    constructor() {
      console.log("Init get quote v3");
      super();
    }

    connectedCallback() {
      console.log("CONNECTED CALLBACK");
      // var $getQuoteBtn = $(this).find("button");
      // var productID = $getQuoteBtn.data("product-id");

      if (window.location.href.indexOf("contact_posted=true#ContactFormGetQuote") > -1 ) {
        T4SThemeSP.Notices("Thanks! We will send you a quote soon!", "success");
      }
      
      // $("#ContactFormGetQuote" + productID).submit(function(e) {
      //   console.log("DOING THIS SUBMIT");
      //   event.preventDefault();
      //   $.ajax({
      //       url: $(this).attr("action"),
      //       type: $(this).attr("method"),
      //       data: $(this).serialize(),
      //       success: function (response) {
      //           T4SThemeSP.Notices("Thanks! We will send you a quote soon!", "success");
      //       },
      //       error: function () {
      //       }
      //   });
      // });
    }

    // connectedCallback() {
    //   var orgUrl = `https://${window.Shopify.shop}`;
    //   var getQuotePopupContainer = $(this).find(".t4s-product-get-quote");
    //   var getQuoteBtn = $(this).find("[data-get-quote-btn]");
      
    //   $(this).on("click", "button", function(e) {
    //     e.preventDefault();
    //     if (getQuoteBtn || getQuotePopupContainer) {
    //       var productID = $(this).data("product-id");
    //       var productHandle = $(this).data("product-handle");
    //       var productTitle = $(this).data("product-title");
    //       var variantID = $(this).data("variant-id");
    //       var variantTitle = $(this).data("variant-title");
          
    //       if (getQuotePopupContainer) {
    //         var $form = $("#ContactFormGetQuote" + productID);
    //         // getQuotePopupContainer.show();
    //         var productInfoText = `${productTitle} ( ${variantName} ) - ${orgUrl}/products/${productHandle}?variant=${a.currentVariant.id}`;
    //         $form.find("[name=contact[product]").text(productInfoText);
            
    //       } else if (getQuoteBtn) {
    //         var rootUrl = $(this).data("root-url");
    //         url = `${o}variants/${variantID}/?section_id=back-in-stock`;
    //         $(this).attr("data-mfp-src", url);
    //       }
    //     }
    //   })
    // }
  }
  customElements.define("get-quote", GetQuote);
});